/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.0 */
import "./week-day-grid.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Grid } from '@atlaskit/primitives/compiled';
var styles = {
  templateColumns: "_yv0eloeq"
};

/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */
var WeekDayGrid = function WeekDayGrid(_ref) {
  var testId = _ref.testId,
    children = _ref.children,
    isHidden = _ref.isHidden;
  var row = /*#__PURE__*/React.createElement(Grid, {
    testId: testId,
    xcss: styles.templateColumns,
    role: "row"
  }, children);
  return isHidden ? /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true"
  }, row) : row;
};
export default WeekDayGrid;